import React from 'react'

export default function Privacy() {
    return (
        <>
            <section className="py-5">
                <div className="container px-5 my-5">
                    <div className="row gx-5 justify-content-center">
                        <div className="col-lg-8 col-xl-10">
                            <div className="text-center">
                                <h2 className="fw-bolder">Privacy Policy</h2>
                                <p className="lead fw-normal text-muted mb-5">
                                    At Uyirmozhy, we respect your privacy and are committed to protecting any personal information you may share with us. This policy explains what information we collect, how we use it, and how we keep it secure.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row gx-5 align-items-center">
                        <div className="col-lg-12">
                            <h4 className="fw-bolder">1. Information We Collect</h4>
                            <p className="lead fw-normal text-muted mb-0">
                                Our website is meant for sharing information about our books, authors, and publishing activities. We do not collect any financial or sensitive personal information.
                                However, if you contact us through a form or by email, we may collect basic details such as your name, email address, and message content so we can respond to you.
                                We may also collect non-personal data such as browser type, device information, and pages visited — this helps us improve our website and understand what readers find useful.
                            </p>
                            <h4 className="fw-bolder">2. How We Use the Information</h4>
                            <p className="lead fw-normal text-muted mb-0">
                                We use the information you provide only to:
                                <ul>
                                    <li>Respond to your inquiries</li>
                                    <li>Improve our website and communication</li>
                                    <li>Share updates about our publications, if you have requested them</li>
                                </ul>
                                We do not sell, rent, or trade your personal information to anyone.
                            </p>
                            <h4 className="fw-bolder">3. Cookies</h4>
                            <p className="lead fw-normal text-muted mb-0">
                                Our website may use small files called cookies to enhance browsing experience or collect anonymous statistics.
                                You can disable cookies in your browser settings at any time — the website will still be accessible.
                            </p>
                            <h4 className="fw-bolder">4. External Links</h4>
                            <p className="lead fw-normal text-muted mb-0">
                                Uyirmozhy’s website may include links to external websites, such as book listings or author pages.
                                We are not responsible for the privacy practices or content of those sites. Please review their individual privacy policies when visiting them.
                            </p>
                            <h4 className="fw-bolder">5. Data Security</h4>
                            <p className="lead fw-normal text-muted mb-0">
                                We take reasonable measures to protect any personal information shared with us.
                                Data is stored securely and is not accessible to unauthorized persons.
                                We do not keep your information longer than necessary to fulfill your request.
                            </p>
                            <h4 className="fw-bolder">6. Changes to This Policy</h4>
                            <p className="lead fw-normal text-muted mb-0">
                                We may update this Privacy Policy from time to time. The latest version will always be available on this page with the updated effective date.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
